import React, { createContext, useContext, useEffect, useState } from 'react';
import { fetchCategories, fetchTopProducts, fetchBestsellers } from '../data/catalog';
import { STATIC_CATEGORIES, STATIC_TOP_PRODUCTS, STATIC_BESTSELLERS } from '../data/staticData';

const CatalogContext = createContext({
  categories: STATIC_CATEGORIES,
  topProducts: STATIC_TOP_PRODUCTS,
  bestsellers: STATIC_BESTSELLERS,
  loading: true,
});

export function CatalogProvider({ children }) {
  const [categories, setCategories] = useState(STATIC_CATEGORIES);
  const [topProducts, setTopProducts] = useState(STATIC_TOP_PRODUCTS);
  const [bestsellers, setBestsellers] = useState(STATIC_BESTSELLERS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const [cats, tops, best] = await Promise.all([
          fetchCategories(),
          fetchTopProducts(),
          fetchBestsellers(),
        ]);
        if (!active) return;
        if (cats && cats.length) setCategories(cats);
        if (tops && tops.length) setTopProducts(tops);
        if (best && best.length) setBestsellers(best);
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => { active = false; };
  }, []);

  return (
    <CatalogContext.Provider value={{ categories, topProducts, bestsellers, loading }}>
      {children}
    </CatalogContext.Provider>
  );
}

export function useCatalog() {
  return useContext(CatalogContext);
}

export default CatalogContext;
